import React, { useEffect, useState } from 'react';

function MainBottom(props) {
  const [ScrollY, setScrollY] = useState(0); // 스크롤값을 저장하기 위한 상태
  const handleFollow = () => {
    setScrollY(window.pageYOffset); // window 스크롤 값을 ScrollY에 저장
  };

  useEffect(() => {
    // console.log('find data childmild ---->>> ScrollY is ', ScrollY); // ScrollY가 변화할때마다 값을 콘솔에 출력
    if (ScrollY === 0) {
      document.getElementById('btn_top').style.display = 'none';
    } else {
      document.getElementById('btn_top').style.display = 'block';
    }
  }, [ScrollY]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow);
    };
    watch(); // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow); // addEventListener 함수를 삭제
    };
  }, []);
  const moveToTop = () => (document.documentElement.scrollTop = 0);

  return (
    <>
      <div id='btn_top' className='sbs_common_top' onClick={moveToTop}>
        <a href='#header' className='footer_btn_gotop'>
          <span className='icon_svg_gotop'>
            <i className='ir'>맨위로</i>
            <svg width='14' height='18' viewBox='0 0 14 18'><path d='M24.018,15.4a.816.816,0,0,1-1.15.006l-4.806-4.8V25.075a.812.812,0,0,1-1.625,0V10.614l-4.806,4.8a.822.822,0,0,1-1.15-.006.81.81,0,0,1,.006-1.144l6.187-6.152h0a.912.912,0,0,1,.256-.169.775.775,0,0,1,.312-.063.814.814,0,0,1,.569.231L24,14.265A.8.8,0,0,1,24.018,15.4Z' transform='translate(-10.247 -7.882)' /></svg>
          </span>
        </a>
      </div>

      <div id="footer" className="footer_wrap">
        <div className="wamark_image_w">
          <a href="http://webwatch.or.kr/" target="_blank" className="wamark_link" title="새창이동">
            <img src="styles/2022/pc/img/WA_Mark_img.png" alt="과학기술정보통신부 Web접근성 마크" className="wamark_image" />
          </a>
        </div>
        <p className="footer_copy">&copy; <em>SBS &amp; SBSi</em></p>
      </div>

    </>
  );
}

export default MainBottom;
